// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"202":"27a3a479","502":"dec4c112","976":"01536f94","1107":"267ae081","2697":"27a3a479","5697":"01536f94","9999":"27a3a479"}[chunkId] + ".chunk.css";
};